import { InjectionToken, Provider } from '@angular/core';
import { CampaignsTagsApiService } from './campaigns-tags-api.service';
import { CampaignsTagsRepository } from './campaigns-tags.repository';

export const HTTP_CAMPAIGNS_TAGS_SERVICE = new InjectionToken<CampaignsTagsRepository>('CampaignsTagsRepository');

export const CAMPAIGNS_TAGS_API_PROVIDER: Provider = {
    provide: HTTP_CAMPAIGNS_TAGS_SERVICE,
    useClass: CampaignsTagsApiService,
};
